import { render, staticRenderFns } from "./PeriodSwitch.vue?vue&type=template&id=6ed2840e"
import script from "./PeriodSwitch.vue?vue&type=script&lang=js"
export * from "./PeriodSwitch.vue?vue&type=script&lang=js"
import style0 from "./PeriodSwitch.vue?vue&type=style&index=0&id=6ed2840e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports